import IconView from "@/app/(site)/_components/Atoms/Icons/IconView"
import Text from "@/app/(site)/_components/Atoms/Text"
import { getLangCode } from "@/app/(site)/_utils/misc"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { t } from "@/translations"
import { usePathname } from "next/navigation"

export default function LensGuide() {
    const langCode = getLangCode(usePathname().split("/")[1]) || ""
    const toggleLensGuideModal = useEcommerceStore(state => state.toggleLensGuideModal)
    return (
        <div className="mb-24 flex cursor-pointer flex-col items-end">
            <div className="flex" onClick={() => toggleLensGuideModal()}>
                <Text size="small" weight="regular">
                    {t(langCode, "product_page.lens_guide")}
                </Text>
                <IconView className="ml-8 h-16 w-16" />
            </div>
        </div>
    )
}
